import "./login.css";
import {useContext, useEffect, useState, useRef} from "react";
import AuthContext from "context/AuthContext";
import ThemeContext from "context/ThemeContext";
import {Navigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import LoginOTP from "./LoginOTP";
import LoginOTPSetup from "./LoginOTPSetup";

const Login = () => {
    const {t: _Ta} = useTranslation("authenticate");
    const {t: tC} = useCustomTranslation(translations);
    const {theme} = useContext(ThemeContext);
    const {user, loginUser, pendingOtp} = useContext(AuthContext);
    const [inputType, setInputType] = useState("password");
    const [buttonState, setButtonState] = useState(false);
    const [buttonContent, setButtonContent] = useState(_Ta("buttons.signin"));
    const [activeError, setActiveError] = useState(false);
    const [activeErrorLogin, setActiveErrorLogin] = useState(false);
    const [iconPass, setIconPass] = useState(<FontAwesomeIcon icon="eye" />);
    const [next] = useSearchParams();
    const url = useRef("/");
    // Nuevo estado para controlar la carga
    const [isLoading, setIsLoading] = useState(true);

    const toggleInput = () => {
        if (inputType === "password") {
            setInputType("text");
            setIconPass(<FontAwesomeIcon icon="eye-slash" />);
        } else {
            setInputType("password");
            setIconPass(<FontAwesomeIcon icon="eye" />);
        }
    };
    const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
    const now = new Date();
    const spinButton = <FontAwesomeIcon icon="circle-notch" className="fa-spin" />;
    const textButton = _Ta("buttons.signin");

    const handleSubmit = (e) => {
        e.preventDefault();
        setActiveError(false);
        setButtonState(true);
        //setButtonContent(spinButton);
        // active error si no da resp
        loginUser(e)
            .then((resp) => {
                // console.log(resp);
                setActiveErrorLogin(!resp.check);
                setButtonState(false);
                setButtonContent(textButton);
                document.body.style.height = "";
            })
            .catch((error) => {
                setActiveError(true);
                setButtonState(false);
                setButtonContent(textButton);
            });
    };

    useEffect(() => {
        document.title = theme.title;
        document.body.style.height = "100%";
        if (next.has("next")) {
            url.current = next.get("next");
        }

        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, [next, theme.title]);

    // Si el usuario ya está autenticado, redirigir
    if (user) {
        document.body.style.height = "";
        return <Navigate to={url.current} />;
    }

    if (isLoading || theme.loading) {
        return (
            <div className="loading-container d-flex justify-content-center align-items-center vh-100">
                <div className="text-center">
                    <FontAwesomeIcon icon="circle-notch" className="fa-spin fa-5x mb-4" style={{color: theme.primaryColor}} />
                </div>
            </div>
        );
    }

    if (pendingOtp?.setup) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 w-100">
                <LoginOTPSetup />
            </div>
        );
    }

    if (pendingOtp) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 w-100">
                <LoginOTP />
            </div>
        );
    }

    return (
        <div className="form-signin w-100 m-auto">
            <form onSubmit={handleSubmit}>
                <div className="col-12 text-center mb-3">
                    <img
                        src={theme.logoLogin || urlStatic + "/images/quamtra_manager-black.svg"}
                        style={{width: "90%", maxWidth: "300px"}}
                        alt="Logo"
                        onError={(e) => {
                            console.error("Error loading logo:", theme.logoLogin);
                            e.target.src = urlStatic + "/images/quamtra_manager-black.svg";
                        }}
                    />
                </div>
                <h1 className="h5 mb-3 fw-normal text-center">
                    {_Ta("title.hello")} {theme.title} APP
                </h1>
                <p className="mb-2 text-center">{_Ta("title.init-session")}</p>
                <p className={`error-message text-center bg-danger text-light ${activeError ? "" : "d-none"}`}>
                    {tC("errorserver")}
                </p>
                <p className={`mb-3 text-center error-message bg-danger text-light ${activeErrorLogin ? "" : "d-none"}`}>
                    {tC("errorlogin")}
                </p>
                <div className="input-group input-group-sm has-validation">
                    <span className="input-group-text bg-transparent" id="email-addon">
                        @
                    </span>
                    <div className="form-floating">
                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            required
                            id="email"
                            placeholder="name@example.com"
                        />
                        <label htmlFor="email">{_Ta("labels.email")}</label>
                    </div>
                </div>
                <div className="input-group">
                    <div className="form-floating">
                        <input
                            type={inputType}
                            className="form-control"
                            name="password"
                            required
                            id="password"
                            placeholder="Password"
                        />
                        <label htmlFor="password">{_Ta("labels.password")}</label>
                    </div>
                    <button className="btn btn-outline-secondary" type="button" onClick={toggleInput}>
                        {iconPass}
                    </button>
                </div>
                <div className="text-center">
                    <a href="/recovery/" style={{color: theme.primaryColor}}>
                        {_Ta("labels.recovery")}
                    </a>
                </div>
                <button
                    className="btn w-100 py-2 mt-3"
                    style={{backgroundColor: theme.primaryColor, borderColor: theme.primaryColor, color: "white"}}
                    type="submit"
                    disabled={buttonState}>
                    {buttonContent}
                </button>
                <p className="mt-4 mb-3 text-body-secondary text-center">&copy;{now.getFullYear()}</p>
            </form>
        </div>
    );
};
export default Login;
